module.exports = __webpack_public_path__ + "media/images/os_cara/glin-eduardo-60c80e02a36496fd929392857dfdd69e.jpg";